import React from 'react';
import AsyncSelect from 'react-select/async';
import {
  ASYNC_SEARCH_END_POSITION,
  ASYNC_SEARCH_MAX_LENGTH,
  ASYNC_SEARCH_START_POSITION,
} from '../../constants/NumberConstants';
import bn from '../../utils/bemnames';
import ErrorBoundary from './ErrorBoundary';

const bem = bn.create('dropdownListAsync');

const DropdownListAsync = (props) => {
  const loadOptions = (inputValue) => {
    if (inputValue.length > 1) {
      if (inputValue.length > ASYNC_SEARCH_MAX_LENGTH) {
        return props
          .loadOptions(inputValue.substring(ASYNC_SEARCH_START_POSITION, ASYNC_SEARCH_END_POSITION))
          .then((res) => res.data);
      }
      return props.loadOptions(inputValue).then((res) => res.data);
    }
  };

  const defaultStyles = {
    control: (base) => ({
      ...base,
      minWidth: 0,
      maxWidth: '100%',
      flexWrap: 'nowrap',
    }),
    container: (base) => ({
      ...base,
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '2px 8px',
      minWidth: 0,
    }),
    menu: (base) => ({
      ...base,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: `${props.maxHeight ? props.maxHeight : 400}px`, // your desired height
    }),
  };

  return (
    <ErrorBoundary>
      <div className={bem.b('')}>
        <AsyncSelect
          cacheOptions
          defaultOptions={props.defaultOptions}
          isMulti={props.isMulti}
          value={props.selectedValue}
          getOptionLabel={(e) => e?.label}
          getOptionValue={(e) => e?.value}
          loadOptions={loadOptions}
          onInputChange={props.handleInputChange}
          onChange={props.handleChange}
          placeholder={props.placeholder}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          maxMenuHeight={props.maxHeight}
          styles={defaultStyles}
          className="insightia-select"
          classNamePrefix="insightia-select"
          isClearable
          isDisabled={props.disabled}
        />
      </div>
    </ErrorBoundary>
  );
};

export default React.memo(DropdownListAsync);
